import styled, { css } from "styled-components"

import MyButton from "../../elements/Button"

const Button = styled(MyButton)`
  border: 1px solid #67c462;
  height: 24px;
  width: 24px;
  background-color: #ffffff;
  background-image: url("https://res.cloudinary.com/dwoc5fknz/image/upload/v1556193906/default.svg");
  background-position: 50% 50%;
  background-size: 60%;
  background-repeat: no-repeat;
  min-width: unset;
  border: none;
  border-radius: 100%;
  cursor: pointer;
  padding: 7px;
  &::before {
    display: none;
  }
  ${({ expand }) =>
    expand &&
    css`
      background-image: url("https://res.cloudinary.com/dwoc5fknz/image/upload/v1556119976/caret-up.svg");

      background-repeat: no-repeat;
      background-size: 100%;
    `}
  ${({ expand }) =>
    !expand &&
    css`
      &:hover {
        box-shadow: none;
      }
    `}
`

export default Button
